export default __webpack_public_path__ + "static/media/icon-valid-pin.9f8d47b4.svg";